<template>
	<div>
	
	<van-row type="flex" class="topdiv" justify-content="center"  flex-direction= "column">
		 <van-col span="6"><van-icon :name="feedback" size="60px"></van-icon></van-col>
	  <van-col span="18" class="title">我的产品</van-col>
	 </van-row>
	
	<div class="Content">
		<van-steps
		  :active="active"
		  active-icon="success"
		  active-color="#38f"		  
		>
		  <van-step>验证设备</van-step>
		  <van-step>选择产品</van-step>
		  <van-step>填写订单</van-step>
		  <van-step>订单支付</van-step>
		</van-steps>
		
		<van-divider content-position="left">第二步：选择可购买的服务产品</van-divider>
		<van-list v-for ="item in productList">
		  <van-card
		    num="1"
		    :price="item.UserPrice"
		    :thumb="item.ImageURL"
			@click="selectItem(item.ProductCode)"
			to ="/oow/info"
			>		
		    <div slot="title" class="itemtitle">
		     {{item.ProductName}}
		    </div>
			<div slot="desc" class="desc">
			 {{item.ProductCode}}
			</div>	
				
			</van-card>
		</van-list>
		
		 <van-button type="danger" class="btnNext" to = "/oow/mypros">下一步</van-button>
		 </div>	
	</div>
</template>

<script>
	import Vue from 'vue'
	import md5 from 'js-md5'	
	import { Dialog } from 'vant';
	export default {
	  name: 'MYPROS',	  
	  data(){
	  		return{		
				feedback: require("@/assets/icon/oow.png"),
				active: '1',	
				productList:[]
	  		}
	  	 
	  }
	}
</script>

<style>
</style>
